import React, { Component } from 'react';
import Select from '../../shared/select';
import ContentHeader from './ContentHeader';

class DueDateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unit: props.defaultUnit,
      amount: props.defaultAmount,
    };
    this.updateField = this.updateField.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.cancelChanges = this.cancelChanges.bind(this);
    this.removeDueDate = this.removeDueDate.bind(this);
  }

  static humanValues = {
    unit: {
      days: 'days',
      weeks: 'weeks',
      months: 'months',
    },
  };

  static defaultProps = {
    defaultUnit: 'days',
  };

  updateField({ target }) {
    const { value, type, name } = target;
    this.setState({
      [name]: type === 'number' ? parseInt(value, 10) : value,
    });
  }

  saveChanges() {
    this.props.updateContent({ dueIn: this.state });
    this.props.toggleEditingDueDate();
  }

  cancelChanges() {
    this.props.toggleEditingDueDate();
  }

  removeDueDate() {
    this.props.updateContent({ dueIn: null });
    this.props.toggleEditingDueDate();
  }

  render() {
    const { unit, amount } = this.state;
    const { humanValues } = DueDateForm;

    const AmountInput = (
      <input
        className="NewInput NewInput--white w-60 mt-8 pr-0"
        ref={n => {
          if (n) n.focus();
        }}
        min="1"
        name="amount"
        onChange={this.updateField}
        type="number"
        value={amount || ''}
      />
    );

    const UnitInput = (
      <Select
        className="mr-4"
        name="unit"
        value={unit}
        onChange={this.updateField}
      >
        <option value="days">{humanValues.unit.days}</option>
        <option value="weeks">{humanValues.unit.weeks}</option>
        <option value="months">{humanValues.unit.months}</option>
      </Select>
    );

    return (
      <div className="PathContent">
        <ContentHeader
          {...this.props}
          onSave={this.saveChanges}
          onCancel={this.cancelChanges}
          savingDisabled={!this.state.amount}
          isEditing
        />
        <div className="PathContent-body">
          <div className="fz-base c-brand-gray-darker">Due Date (optional)</div>
          <div className="c-brand-gray-darker">
            {AmountInput} {UnitInput} after the step becomes available
          </div>
          {this.props.defaultAmount && (
            <button
              type="button"
              className="u-linkBtn mt-16"
              onClick={this.removeDueDate}
            >
              No Due Date
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default DueDateForm;
